interface countMatchingWallpapersTypes {
  title?: string;
  category?: string;
  duration?: string;
}

async function countMatchingWallpapers(params: countMatchingWallpapersTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const baseUrl = new URL(`${serverURL}/api/wallpapers/count`);

  const searchParams = new URLSearchParams({});

  if (params.title) searchParams.set("title", params.title);
  if (params.category) searchParams.set("category", params.category);
  if (params.duration) searchParams.set("duration", params.duration);

  baseUrl.search = searchParams.toString();

  try {
    const res = await fetch(baseUrl.toString(), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await res.json();
    return result.count;
  } catch (error) {
    return null;
  }
}

export default countMatchingWallpapers;
